import browserRetina from 'marketing-website/media/images/pages/why-marvel/browser@2x.jpg';
import buttonsRetina from 'marketing-website/media/images/pages/why-marvel/buttons@2x.png';
import peopleRetina from 'marketing-website/media/images/pages/why-marvel/people@2x.png';
import photosRetina from 'marketing-website/media/images/pages/why-marvel/photos@2x.jpg';
import interactiveRetina from 'marketing-website/media/images/pages/why-marvel/interactiveFallback@2x.png';
import tabFrontRetina from 'marketing-website/media/images/pages/why-marvel/tabFront@2x.png';
import tabBackRetina from 'marketing-website/media/images/pages/why-marvel/tabBack@2x.png';
import collaborationRetina from 'marketing-website/media/images/pages/why-marvel/collaboration@2x.png';
import illustrationRetina from 'marketing-website/media/images/pages/why-marvel/illustration@2x.png';
import patternRetina from 'marketing-website/media/images/pages/why-marvel/pattern@2x.png';

const assets = {
  browser: {
    alt: 'Open collaboration and centralised feedback',
    maxWidth: 1170,
    src: browserRetina,
  },
  buttons: {
    src: buttonsRetina,
    alt: 'Interactive prototypes will reinvent how you showcase design work',
  },
  people: {
    src: peopleRetina,
    alt: 'Interactive prototypes will reinvent how you showcase design work',
  },
  photos: {
    src: photosRetina,
    alt: 'Interactive prototypes will reinvent how you showcase design work',
  },
  interactive: {
    src: interactiveRetina,
    alt: 'Interactive prototypes will reinvent how you showcase design work',
  },
  tabFront: {
    src: tabFrontRetina,
    alt: 'Open collaboration and centralised feedback',
  },
  tabBack: {
    src: tabBackRetina,
    alt: 'Open collaboration and centralised feedback',
  },
  collaboration: {
    src: collaborationRetina,
    alt: 'Open collaboration and centralised feedback',
  },
  illustration: {
    src: illustrationRetina,
    alt: 'Power up your workflow and get more done with integrations',
  },
  pattern: {
    src: patternRetina,
    alt: 'Power up your workflow and get more done with integrations',
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/why-marvel/assets.js